module.exports = __webpack_public_path__ + "static/img/social-fb-w.925473b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/social-fb-w.png
// module id = 135
// module chunks = 0